import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreLink?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreLink,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 md:mb-8">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-medium tracking-wider text-primary-600">
            <span className="h-1 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-1.5 max-w-2xl text-sm text-foreground-500">{desc}</p>
        )}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}